import moment from 'moment-timezone';
import * as _ from 'underscore';
import { timeZones } from '../../../../../Common/Forms/data/time-zones';
import { Subscription } from 'rxjs';
export enum ScheduleType {
    immediate,
    scheduledDate,
    recurring
}

export class DeliverySchedule {
    timeZone?: string;
    scheduleType: ScheduleType;
    scheduledDateUTC?: Date;

    // recurring: BriefingRecurrencePatternModel;

    private dateFormat: string = 'dddd, MMMM DD, YYYY h:mm A z';
    private offsetDateFormat: string = 'dddd, MMMM DD, YYYY h:mm A z ';

    subscriptions: Subscription[] = [];

    // Simple now/later mode
    constructor(scheduledDateUTC: Date, timeZone: string) {
        this.timeZone = timeZone ?? 'UTC';
        if (!scheduledDateUTC) {
            this.scheduleType = ScheduleType.immediate;
            this.scheduledDateUTC = new Date();
        } else {
            this.scheduleType = ScheduleType.scheduledDate;
            this.scheduledDateUTC = scheduledDateUTC;
        }
    }

    // TODO :
    /* constructor(fullModelWithRecurring) {

    }*/

    public equals(other: DeliverySchedule): boolean {
        if (this.scheduleType !== other.scheduleType) {
            return false;
        }

        if (this.scheduleType !== ScheduleType.immediate) {
            if (this.scheduledDateUTC !== other.scheduledDateUTC) {
                return false;
            }

            if (this.timeZone !== other.timeZone) {
                return false;
            }
        }

        /* if (this.recurring !== null && other.recurring !== null && !this.recurring.equals(other.recurring)) {
            return false;
        }*/

        return true;
    }

    public getDisplayString(timezone: string = this.timeZone, dateFormat?: string): string {
        let returnString: string;
        if (this.scheduleType === ScheduleType.immediate) {
            returnString = 'Briefing.immediate';
        } else if (this.scheduledDateUTC) {
            if (timezone === 'UTC') {
                returnString = moment(this.scheduledDateUTC).tz(timezone).format(dateFormat ? dateFormat + ' z' : this.dateFormat);
            } else {
                const offsetString = ' z ([GMT]Z)';
                returnString = moment(this.scheduledDateUTC).tz(timezone).format(dateFormat ? dateFormat + offsetString : this.offsetDateFormat);
            }

        } else {
            // returnString = this.formatRecurringTime(this.recurring);
        }

        return returnString;
    }

    public isValid(): boolean {
        if (this.scheduleType === ScheduleType.immediate) {
            return true;
        }

        const currentDate = new Date();
        if (this.scheduledDateUTC <= currentDate) {
            return false;
        }

        return true;
    }
}
